import { Alert, Box, Chip, Typography } from "@mui/material";

const formatMilk = (value) => typeof value === "number" && Number.isFinite(value) && value >= 0
    ? `${value.toLocaleString("el-GR", { minimumFractionDigits: 3, maximumFractionDigits: 3 })} kg`
    : "Μη διαθέσιμη";

const formatDate = (value) => value && !Number.isNaN(new Date(value).getTime())
    ? new Date(value).toLocaleDateString("el-GR", { timeZone: "Europe/Athens" }) : "Δεν έχει καταχωρηθεί";

export default function MilkingPeriodSummary({ summary }) {
    if (!summary) return null;
    const { periodState, calculationStatus } = summary;
    const hiddenTotals = ["stale", "unavailable", "not-calculated"].includes(calculationStatus);
    const notices = {
        stale: "Έχουν αλλάξει στοιχεία αυτής της περιόδου. Κάντε ξανά τον υπολογισμό της πραγματικής και τυπικής γαλακτοπαραγωγής για να εμφανιστούν ενημερωμένα σύνολα.",
        "not-calculated": "Δεν έχει γίνει υπολογισμός γαλακτοπαραγωγής για αυτή την περίοδο.",
        unavailable: "Δεν υπάρχουν διαθέσιμα αποτελέσματα γαλακτοπαραγωγής. Δείτε τα προβλήματα κατά τον υπολογισμό της συνολικής γαλακτοπαραγωγής.",
        partial: "Η πραγματική παραγωγή είναι μερική. Υπάρχουν μετρήσεις ή διαστήματα που δεν χρησιμοποιήθηκαν στον υπολογισμό.",
    };
    return <Box component="section" aria-label="Σύνολα επιλεγμένης περιόδου άμελξης"
        sx={{ p: 2, mb: 2, border: "1px solid", borderColor: "divider", borderRadius: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 1, mb: 2 }}>
            <Typography sx={{ fontWeight: 700 }}>Περίοδος άμελξης</Typography>
            <Chip label={periodState === "closed" ? "Έχει λήξει" : periodState === "ongoing" ? "Σε εξέλιξη" : "Η κατάσταση δεν είναι διαθέσιμη"}
                color={periodState === "closed" ? "default" : "info"} size="small" />
            {periodState === "closed" && <Typography variant="body2">Ημερομηνία λήξης: {formatDate(summary.endedAt)}</Typography>}
        </Box>
        <Box sx={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 2 }}>
            <Box>
                <Typography variant="body2">Πραγματική γαλακτοπαραγωγή</Typography>
                <Typography sx={{ fontWeight: 700, fontSize: "1.25rem" }}>{formatMilk(hiddenTotals ? null : summary.totalMilk)}</Typography>
                {periodState === "ongoing" && !hiddenTotals && summary.totalMilk != null
                    && <Typography variant="caption">Παραγωγή μέχρι τους καταχωρημένους ελέγχους</Typography>}
            </Box>
            <Box>
                <Typography variant="body2">Τυπική γαλακτοπαραγωγή</Typography>
                <Typography sx={{ fontWeight: 700, fontSize: "1.25rem" }}>{formatMilk(hiddenTotals ? null : summary.totalStandardMilk)}</Typography>
            </Box>
        </Box>
        {notices[calculationStatus] && <Alert severity={calculationStatus === "not-calculated" ? "info" : "warning"} sx={{ mt: 2 }}>
            {notices[calculationStatus]}
        </Alert>}
    </Box>;
}
